// https://docs.stripe.com/connect/embedded-appearance-support-dark-mode
export const darkModeAppearanceVariables = {
    colorPrimary: "hsl(142.1, 76.2%, 36.3%)",
    colorText: "#C9CED8",
    colorBackground: "hsl(24, 9.8%, 10%)",
    buttonSecondaryColorBackground: "#2B3039",
    buttonSecondaryColorText: "#C9CED8",
    colorSecondaryText: "#8C99AD",
    actionSecondaryColorText: "#C9CED8",
    actionSecondaryTextDecorationColor: "#C9CED8",
    colorBorder: "#2B3039",
    colorDanger: "#F23154",
    badgeNeutralColorBackground: "#1B1E25",
    badgeNeutralColorBorder: "#2B3039",
    badgeNeutralColorText: "#8C99AD",
    badgeSuccessColorBackground: "#152207",
    badgeSuccessColorBorder: "#20360C",
    badgeSuccessColorText: "#3EAE20",
    badgeWarningColorBackground: "#400A00",
    badgeWarningColorBorder: "#5F1400",
    badgeWarningColorText: "#F27400",
    badgeDangerColorBackground: "#420320",
    badgeDangerColorBorder: "#61092D",
    badgeDangerColorText: "#F46B7D",
    offsetBackgroundColor: "#1B1E25",
    formBackgroundColor: "#14171D",
    overlayBackdropColor: "rgba(0,0,0,0.8)",
};
export const lightModeAppearanceVariables = {
    colorPrimary: "hsl(142.1, 76.2%, 36.3%)",
    overlayBackdropColor: "rgba(0,0,0,0.8)",
}